import { FlowComponent } from "solid-js";

const Body: FlowComponent<{ class?: string }> = (props) => (
  <div class="container mx-auto" classList={{ [`${props.class}`]: !!props.class }}>
    {props.children}
  </div>
);

export default Body;
